
import { faBanSmoking, faBath, faBlenderPhone, faBottleWater, faBroom, faCouch, faEthernet, faFan, faFireExtinguisher, faKitchenSet, faLightbulb, faMartiniGlass, faMattressPillow, faMugHot, faMugSaucer, faShower, faTelevision, faToiletPaper, faTrashCan, faWifi, faWind } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const viewsText: any = {
  'City view': "hotel.city_view", //'Hướng thành phố',
  'Street view': "hotel.street_view", //'Hướng thành phố',
  'Garden view': "hotel.garden_view", //'Hướng vườn',
  'Ocean view': "hotel.ocean_view", //'Hướng biển',
  'Lake view': "hotel.lake_view", //'Hướng sông',
  'Outdoor view': 'hotel.outdoor_view'
}

export const groupFacilityTextVI: any = {
  'Languages spoken': "Ngôn ngữ",
  "Access": "Dễ dàng tiếp cận",
  "Available in all rooms": "Có trong tất cả phòng",
  "Getting around": "Đi lại",
  "Things to do, ways to relax": "Thư giãn & Vui chơi giải trí",
  "Internet access": "Truy cập Internet",
  "Dining, drinking, and snacking": "Ăn uống",
  "Services and conveniences": "Dịch vụ và tiện nghi",
  "For the kids": "Dành cho trẻ em",
  "Land sports": "Thể thao trên đất liền",
}

export const facilitiesIcon: any = {
  37: <FontAwesomeIcon icon={faBath} />,
  38: <FontAwesomeIcon icon={faShower} />,
  141: <FontAwesomeIcon icon={faToiletPaper} />,
  31: <FontAwesomeIcon icon={faWifi} />,
  75: <FontAwesomeIcon icon={faWifi} />,
  77: <FontAwesomeIcon icon={faEthernet} />,
  139: <FontAwesomeIcon icon={faBlenderPhone} />,
  35: <FontAwesomeIcon icon={faTelevision} />,
  36: <FontAwesomeIcon icon={faTelevision} />,
  25: <FontAwesomeIcon icon={faWind} />,
  212: <FontAwesomeIcon icon={faMugSaucer} />,
  49: <FontAwesomeIcon icon={faBottleWater} />,
  211: <FontAwesomeIcon icon={faMugHot} />,
  275: <FontAwesomeIcon icon={faKitchenSet} />,
  42: <FontAwesomeIcon icon={faKitchenSet} />,
  147: <FontAwesomeIcon icon={faKitchenSet} />,
  29: <FontAwesomeIcon icon={faLightbulb} />,
  228: <FontAwesomeIcon icon={faCouch} />,
  15: <FontAwesomeIcon icon={faBanSmoking} />,
  85: <FontAwesomeIcon icon={faFan} />,
  209: <FontAwesomeIcon icon={faBroom} />,
  280: <FontAwesomeIcon icon={faFireExtinguisher} />,
  2643: <FontAwesomeIcon icon={faMattressPillow} />,
  2665: <FontAwesomeIcon icon={faTrashCan} />
}